import romanNumerals from "roman-numerals";

const { toArabic, toRoman } = romanNumerals;

export const romanToNumber = (roman: string) => toArabic(roman);

export const numberToRoman = (number: number) => toRoman(number);

const { floor } = Math;
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const A = "A".charCodeAt(0);

export const alphaToNumber = (alpha: string) => {
  let number = 0;
  alpha = alpha.toUpperCase().replace(/[^A-Z]/g, "");

  for (let i = 0; i < alpha.length; i++) {
    if (i > 0) number++;
    number = number * 26 + (alpha.charCodeAt(i) - A);
  }

  return number + 1;
};

export const numberToAlpha = (number: number) => {
  let string = "";
  number--;

  while (number > -1) {
    string = alphabet[number % 26] + string;
    if (number > 25) {
      number = floor((number - 26) / 26);
    } else {
      break;
    }
  }

  return string;
};

export type NumberFormat =
  | "decimal"
  | "roman"
  | "lowerRoman"
  | "alpha"
  | "lowerAlpha";

export const numberFormatsMap: Record<NumberFormat, string> = {
  decimal: "Decimal",
  alpha: "Alphabetic",
  lowerAlpha: "Lowercase Alphabetic",
  roman: "Roman Numerals",
  lowerRoman: "Lowercase Roman Numerals",
};

export const numberFormats = (
  Object.keys(numberFormatsMap) as NumberFormat[]
).map((value) => ({
  label: numberFormatsMap[value],
  value,
}));

export const formatNumber = (n: number, format: NumberFormat) => {
  if (format !== "decimal") n |= 0;
  const neg = n < 0 ? "-" : "";
  n = Math.abs(n);
  let result = "";
  switch (format) {
    case "roman":
      result = numberToRoman(n);
      break;
    case "lowerRoman":
      result = numberToRoman(n).toLowerCase();
      break;
    case "alpha":
      result = numberToAlpha(n);
      break;
    case "lowerAlpha":
      result = numberToAlpha(n).toLowerCase();
      break;
    default:
      result = "" + n;
  }
  return neg + result;
};
